import { render, staticRenderFns } from "./dqs-avg-of-studies.vue?vue&type=template&id=c9159a9e&scoped=true"
import script from "./dqs-avg-of-studies.vue?vue&type=script&lang=js"
export * from "./dqs-avg-of-studies.vue?vue&type=script&lang=js"
import style0 from "./dqs-avg-of-studies.vue?vue&type=style&index=0&id=c9159a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9159a9e",
  null
  
)

export default component.exports